import { extendTheme } from "@chakra-ui/react"

import colors from "./colors"
import components from "./components"
import fonts from "./fonts"

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: () => ({
      body: {
        background: "primary.white.100",
        fontFamily: "riforma.regular",
        overflowX: "hidden",
      },
    }),
  },
  shadows: {
    elevation: {
      30: "0px 6px 6px 0px rgba(25, 79, 101, 0.05), 0px 2px 2px 0px rgba(25, 79, 101, 0.05)",
      70: "0px 2px 2px 0px rgba(25, 79, 101, 0.05), 0px 6px 6px 0px rgba(25, 79, 101, 0.05), 0px 16px 16px 0px rgba(25, 79, 101, 0.05)",
    },
  },
  fonts,
  colors,
  components,
})

export default theme
